import {Field} from "@/Components/forms";

export function makeField<T = string | any>(name: string, placeholder?: string, initialValue?: T) {
  return Field.make<T>(name, placeholder, initialValue);
}
